import { render, staticRenderFns } from "./AssignmentActionModal.vue?vue&type=template&id=dddb33ba&scoped=true&"
import script from "./AssignmentActionModal.vue?vue&type=script&lang=js&"
export * from "./AssignmentActionModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentActionModal.vue?vue&type=style&index=0&id=dddb33ba&prod&scoped=true&lang=css&"
import style1 from "./AssignmentActionModal.vue?vue&type=style&index=1&id=dddb33ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dddb33ba",
  null
  
)

export default component.exports